import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-585a8470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "head" }
const _hoisted_2 = { class: "parallax" }
const _hoisted_3 = { class: "parallax-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Välkommen till")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Våra kunder vill ha mer än en frisörsalong")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-calendar me-2",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Boka tid ")
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<section id=\"info\" data-v-585a8470><div class=\"row\" data-v-585a8470><div class=\"col-md-8\" data-v-585a8470><h2 class=\"section-title\" data-v-585a8470>at. Stockholm</h2><p data-v-585a8470> Vår trendiga lilla salong ligger på Hagagatan nära Odenplan. Här arbetar Sanne, Mikaela, Josefin och Julia som har flera års erfarenhet i branschen. Vi vill att ni kunder ska känna er trygga och nöjda när ni besöker oss. Därför lägger vi god tid på våra bokningar just för att ge er en professionell behandling. </p><p data-v-585a8470> Vi arbetar med Schwarzkopf professional och det senaste veganska märket Authentic beauty concept. Det ska vara hållbart och skonsamt för både hår och natur. </p><p data-v-585a8470> Du kan skicka meddelande för att boka tid på vår Facebooksida salong at.stockholm. Eller kika in vår instagram at.stockholm för bokning eller få inspiration och se hår vi gör på salongen. </p><p data-v-585a8470>Varmt välkomna in till oss!</p></div><div class=\"col-md-4\" data-v-585a8470><div id=\"carouselExampleFade\" class=\"carousel slide carousel-fade\" data-bs-ride=\"carousel\" data-v-585a8470><div class=\"carousel-inner\" data-v-585a8470><div class=\"carousel-item active\" data-v-585a8470><img src=\"/img/s1.jpg\" class=\"d-block w-100\" data-v-585a8470></div><div class=\"carousel-item\" data-v-585a8470><img src=\"/img/s2.jpg\" class=\"d-block w-100\" data-v-585a8470></div><div class=\"carousel-item\" data-v-585a8470><img src=\"/img/s3.jpg\" class=\"d-block w-100\" data-v-585a8470></div><div class=\"carousel-item\" data-v-585a8470><img src=\"/img/s4.jpg\" class=\"d-block w-100\" data-v-585a8470></div></div><button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselExampleFade\" data-bs-slide=\"prev\" data-v-585a8470><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-585a8470></span><span class=\"visually-hidden\" data-v-585a8470>Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselExampleFade\" data-bs-slide=\"next\" data-v-585a8470><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-585a8470></span><span class=\"visually-hidden\" data-v-585a8470>Next</span></button></div></div></div><div class=\"row mt-5\" data-v-585a8470><div class=\"col-md-8 offset-md-2 text-center\" data-v-585a8470><img src=\"/img/tidning1-1024x700.jpg\" class=\"img-fluid img-paper\" data-v-585a8470></div></div></section>", 1)
const _hoisted_9 = { id: "kontakt" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<h1 class=\"section-title\" data-v-585a8470>Kontakta oss</h1><div class=\"row\" data-v-585a8470><div class=\"col-md-3 col-sm-6\" data-v-585a8470><img src=\"/img/mikaela.jpg\" class=\"img-fluid\" data-v-585a8470><p data-v-585a8470>Mikaela Törnkvist</p><p data-v-585a8470><a href=\"tel:070-419 45 25\" data-v-585a8470>070-419 45 25</a></p></div><div class=\"col-md-3 col-sm-6\" data-v-585a8470><img src=\"/img/sanne.jpg\" class=\"img-fluid\" data-v-585a8470><p data-v-585a8470>Sanne Jensen</p><p data-v-585a8470><a href=\"tel:070-476 53 50\" data-v-585a8470>070-476 53 50</a></p></div><div class=\"col-md-3 col-sm-6\" data-v-585a8470><img src=\"/img/josefin.jpg\" class=\"img-fluid\" data-v-585a8470><p data-v-585a8470>Josefin Törmä</p><p data-v-585a8470><a href=\"tel:070-297 87 86\" data-v-585a8470>070-297 87 86</a></p></div><div class=\"col-md-3 col-sm-6\" data-v-585a8470><img src=\"/img/julia-225x300-1.jpg\" class=\"img-fluid\" data-v-585a8470><p data-v-585a8470>Julia Hemlén</p><p data-v-585a8470><a href=\"tel:070-487 48 51\" data-v-585a8470>070-487 48 51</a></p></div></div>", 2)
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-calendar me-2",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Boka tid ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { id: "hittaoss" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "section-title" }, "Hitta oss"),
    /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-md-8 offset-md-2" }, [
        /*#__PURE__*/_createElementVNode("iframe", {
          width: "100%",
          height: "450",
          style: {"border":"0"},
          loading: "lazy",
          allowfullscreen: "",
          src: "https://www.google.com/maps/embed/v1/place?key=AIzaSyCBQMXKtu4cr6sdFGRl17EszNksEJY5wtU&q=Hagagatan%2037+11347+Stockholm"
        }, "\n            ")
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typewriter = _resolveComponent("Typewriter")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", null, [
            _createVNode(_component_Typewriter, {
              class: "typewriter",
              text: ['vår salong', 'oss', 'AT.STOCKHOLM']
            }, null, 8, ["text"])
          ]),
          _hoisted_5,
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: "/boka",
              class: "btn btn-lg btn-primary btn-boka"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", null, [
        _hoisted_10,
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: "/boka",
            class: "btn btn-lg btn-primary btn-boka"
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_14
  ]))
}